<template>
  <div :class="['tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-4 tw-py-2', colorClass]">
    <div>
      <ExclamationCircle v-if="type === 'info'" class="tw-h-5 tw-w-5" />
      <TablerLock v-else-if="type === 'lock'" />
      <ExclamationTriangle v-else class="tw-h-5 tw-w-5" />
    </div>
    <div class="tw-flex-1 tw-text-left tw-text-xs">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import ExclamationCircle from './Icons/ExclamationCircle.vue';
import ExclamationTriangle from './Icons/ExclamationTriangle.vue';

import TablerLock from '@/studioComponents/Icons/tabler/TablerLock.vue';

export default defineComponent({
  name: 'StudioAlertBanner',
  components: {
    ExclamationCircle,
    ExclamationTriangle,
    TablerLock
  },
  props: {
    type: {
      type: String as PropType<'info' | 'warning' | 'error' | 'lock'>,
      required: true
    }
  },
  computed: {
    colorClass(): string {
      if (this.type === 'info') {
        return 'tw-bg-blue-100 tw-text-blue-700';
      }
      if (this.type === 'error') {
        return 'tw-bg-red-100 tw-text-red-700';
      }
      if (this.type === 'warning') {
        return 'tw-bg-yellow-100 tw-text-yellow-700';
      }
      if (this.type === 'lock') {
        return 'tw-border tw-bg-deep-orange-50 tw-border-deep-orange-200 tw-text-deep-orange-900';
      }
      return '';
    }
  }
});
</script>
